import { uploadPhoto as apiUploadPhoto } from './api';

// Image display URLs default to production. For local/localtunnel testing set
// REACT_APP_IMAGE_BASE_URL to an empty string so photos resolve to same-origin
// relative paths served by the local backend through CRA's dev proxy.
const API_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL ?? "https://api.theuniflow.com";

class ImageService {
  /**
   * Upload a photo file and return the response data (includes imageId).
   */
  uploadPhoto = async (file) => {
    try {
      const response = await apiUploadPhoto(file);
      return response.data;
    } catch (error) {
      console.error('Error uploading photo:', error);
      throw error;
    }
  }

  /**
   * Construct the public URL for a stored photo by its numeric ID.
   * Returns null when id is falsy so callers can safely guard with a truthiness check.
   */
  getImageUrl = (id) => {
    if (!id) return null;
    return `${API_BASE_URL}/api/photos/${id}`;
  }
}

const imageService = new ImageService();
export default imageService;